module.exports = __webpack_public_path__ + "static/media/supplier-related-party-white.b2ca1822.svg";